import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { t } from "@/lib/i18n";
import { path } from "@/lib/routes";

export default function NotFound() {
  useSeo("notFound");
  return (
    <section className="safe-x max-w-7xl mx-auto py-32" data-testid="not-found-page">
      <h1 className="text-4xl sm:text-5xl font-semibold text-forest">{t("notFound.title")}</h1>
      <Link to={path("home")} className="mt-8 inline-flex items-center min-h-[52px] px-7 rounded-full bg-forest text-cream font-semibold" data-testid="not-found-home-link">{t("notFound.link")}</Link>
    </section>
  );
}
